import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@/assets/styles/tailwind.css'
import '@/assets/styles/fonts.css'
import '@/assets/styles/index.css'
import dateFilter from "@/filter/dateFilter";
import VueMeta from "vue-meta";
import '@/map/index'

Vue.config.productionTip = true

// Vue.use(ElementUI)
Vue.use(dateFilter)
Vue.use(VueMeta)


// 注册全局日期过滤器（格式：2025年05月21日）


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



